import React from 'react'
import './About.css'

function About() {
  return (
    <div>
      <div className='profile-container'>
        <div className="about-container">
          <span><b>About us</b></span>
          <h1>A small creative team excited to<br /> create beautiful things</h1>
          <p>
            Born out of a shared passion for design and innovation, we're a dedicated team <br /> committed to turning visions into impactful digital realities.
          </p>
          <div className="about-img">
            <img src="https://crator.tailwindawesome.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fteam.e941aa7d.jpg&w=1080&q=75" alt="" className="about" />
          </div>
        </div>
      </div>



      <div className="profile-container">
        <div className="about-containers">
          <div className="about-text">
            <span>Our vision</span>
            <h2>We believe in the power of <br /> creative ideas</h2>
            <p>
              In the heart of our company lies a strong belief in the transformative power of ideas. <br />Leveraging innovation and originality, we aim to deliver results that exceed <br />expectations.
            </p>

            <div className="hero-box">
            <strong>
              <div>
                <div className='about-icon'>
                  <i class="fas fa-shield-alt"></i>
                </div>
                <h3>Full transparency</h3>
              </div>
              <p>
                User experience is paramount. We build for <br /> impact, intuitiveness, and joy.
              </p>
            </strong>

            <strong>
              <div>
                <div className='about-icon'>
                  <i class="fas fa-shield-alt"></i>
                </div>
                <h3>Full transparency</h3>
              </div>
              <p>
                User experience is paramount. We build for <br /> impact, intuitiveness, and joy.
              </p>
            </strong>
            </div>
          </div>
          <img src="https://crator.tailwindawesome.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fvalues.67a17160.jpg&w=750&q=75" className='team white-board' alt="" />
        </div>
      </div>

      <div className="profile-container">
        <div className="about-containers">
        <img src="https://crator.tailwindawesome.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fhandbook.9e7380eb.jpg&w=384&q=75" className='team' alt="" />
          <div className="about-text">
            <span>Our vision</span>
            <h2>How we work and collaborate with <br /> our clients</h2>
            <p>
            Our work philosophy revolves around active collaboration and open dialogue. We <br /> engage with clients every step of the way, ensuring their vision is at the heart of our <br />designs and strategies.
            </p>

            <div className="hero-box">
            <strong>
              <div>
                <div className='about-icon'>
                  <i class="fas fa-shield-alt"></i>
                </div>
                <h3> User focused </h3>
              </div>
              <p>
              User experience is paramount. We build for <br /> impact, intuitiveness, and joy.
              </p>
            </strong>

            <strong>
              <div>
                <div className='about-icon'>
                  <i class="fas fa-shield-alt"></i>
                </div>
                <h3>Clear communication</h3>
              </div>
              <p>
              Clarity guides our interactions. We ensure <br /> you're informed and involved.
              </p>
            </strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default About